module.exports = __webpack_public_path__ + "static/pattern-desktop-4c6ad0a5d0a1fc75a809df81edf275c4.jpg";